import { createIcon } from '@chakra-ui/icons'

// using `path`
export const TeamworkIcon = createIcon({
  displayName: 'TeamworkIcon',
  viewBox:"0, 0, 800,800",

  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (<g transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
  fill="black" stroke="none">
  <path d="M2000 6980 c-517 -12 -754 -21 -775 -29 -100 -40 -136 -180 -69 -269
  40 -52 75 -62 221 -62 156 0 176 -8 171 -73 -3 -37 -7 -44 -38 -59 -30 -15
  -65 -18 -235 -18 -189 0 -202 -2 -240 -23 -125 -71 -125 -243 0 -314 37 -21
  53 -23 202 -23 89 0 173 -4 187 -10 36 -13 46 -58 18 -80 -17 -14 -58 -18
  -264 -24 -275 -7 -303 -14 -362 -89 -29 -36 -31 -45 -31 -116 0 -70 3 -81 28
  -114 55 -72 84 -80 330 -86 232 -6 236 -7 237 -57 0 -39 -25 -47 -198 -62
  -250 -21 -312 -57 -320 -187 -3 -53 0 -65 26 -106 21 -32 45 -54 78 -70 l49
  -24 868 -3 867 -3 1 -62 c1 -34 4 -120 8 -191 8 -174 2 -169 203 -151 135 12
  151 15 203 45 117 67 257 199 445 419 30 35 81 84 114 108 l58 43 187 0 c183
  0 188 1 209 23 l22 23 0 680 0 681 -23 21 c-23 21 -30 22 -269 22 l-247 0 -21
  30 c-12 16 -40 41 -63 54 -52 31 -372 142 -464 161 -82 18 -136 17 -1113 -5z"/>
  <path d="M4982 6919 c-26 -13 -55 -39 -70 -62 -27 -40 -27 -43 -32 -262 -4
  -168 -8 -226 -19 -238 -17 -21 -64 -22 -81 -2 -7 8 -18 84 -26 182 -16 187
  -36 252 -93 292 -63 45 -159 40 -217 -11 -74 -65 -68 6 -74 -973 l-5 -880
  -191 -5 c-141 -4 -195 -9 -207 -19 -20 -16 -22 -74 -7 -226 7 -73 17 -113 35
  -150 56 -109 201 -265 424 -455 35 -30 84 -81 108 -114 l43 -58 0 -205 c0
  -203 0 -204 25 -228 l24 -25 679 0 679 0 24 26 c24 26 24 26 27 291 l3 264 35
  31 c19 17 43 47 53 67 36 71 152 441 158 504 6 67 -24 1685 -33 1774 -7 66
  -37 112 -94 141 -84 44 -194 9 -231 -72 -15 -33 -19 -66 -19 -173 0 -130 0
  -132 -26 -152 -35 -27 -59 -26 -88 2 -22 22 -23 30 -28 238 -6 236 -12 265
  -67 312 -83 69 -209 51 -271 -40 -24 -35 -25 -45 -30 -218 -5 -194 -11 -215
  -55 -215 -46 0 -50 17 -55 274 -6 257 -12 290 -63 344 -58 63 -157 79 -235 41z"/>
  <path d="M999 4894 c-24 -26 -24 -26 -27 -291 l-3 -264 -35 -31 c-19 -17 -43
  -47 -53 -67 -36 -71 -152 -441 -158 -504 -6 -67 24 -1685 33 -1774 7 -66 37
  -112 94 -141 84 -44 194 -9 231 72 15 33 19 66 19 173 0 130 0 132 26 152 35
  27 59 26 88 -2 22 -22 23 -30 28 -238 6 -236 12 -265 67 -312 83 -69 209 -51
  271 40 24 35 25 45 30 218 5 194 11 215 55 215 46 0 50 -17 55 -274 6 -257 12
  -290 63 -344 90 -97 260 -75 316 40 19 41 21 61 21 244 0 224 5 247 57 252 46
  5 55 -20 69 -196 14 -167 24 -210 60 -258 58 -79 183 -86 257 -16 66 62 61 -1
  67 967 l5 880 191 5 c141 4 195 9 207 19 20 16 22 74 7 226 -12 120 -32 163
  -129 285 -64 79 -168 180 -335 325 -37 33 -86 84 -107 114 l-39 54 0 204 c0
  203 0 204 -25 228 l-24 25 -679 0 -679 0 -24 -26z"/>
  <path d="M4029 3725 c-122 -11 -142 -16 -190 -43 -122 -70 -262 -201 -449
  -421 -30 -35 -81 -84 -114 -108 l-58 -43 -189 0 c-176 0 -190 -1 -209 -20 -20
  -20 -20 -33 -20 -703 l0 -684 23 -21 c23 -21 30 -22 269 -22 l247 0 21 -30
  c12 -16 40 -41 64 -55 55 -32 402 -150 486 -165 49 -9 193 -9 595 0 1109 24
  1240 28 1270 40 100 39 136 179 69 268 -40 52 -75 62 -221 62 -156 0 -176 8
  -171 73 3 37 7 44 38 59 30 15 65 18 230 18 168 0 201 3 236 19 131 60 137
  246 9 318 -37 21 -53 23 -202 23 -89 0 -173 4 -187 10 -36 13 -46 58 -18 80
  17 14 58 18 264 24 275 7 303 14 362 89 29 36 31 45 31 116 0 70 -3 81 -28
  114 -55 72 -84 80 -330 86 -232 6 -236 7 -237 57 0 39 25 47 198 62 250 21
  312 57 320 187 3 53 0 65 -26 106 -21 32 -45 54 -78 70 l-49 24 -866 3 -866 3
  -6 121 c-4 67 -7 152 -7 189 0 61 -3 70 -26 88 -15 12 -32 20 -38 20 -6 -1
  -72 -7 -147 -14z"/>
  </g>
    
  ),
})
